import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  SupportFAQ,
  SupportWorksheet,
  SupportMagnetBlock,
  SupportInquiry,
  type SupportTab,
} from "@/features/support";

/**
 * SupportPage - Support 페이지 래퍼
 * 역할: 탭 네비게이션 및 라우팅 처리
 * 비즈니스 로직은 features/support에서 관리
 */
export function SupportPage() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<SupportTab>("faq");

  // URL의 state에서 초기 탭 설정
  useEffect(() => {
    const state = location.state as { tab?: number } | null;
    const params = new URLSearchParams(location.search);
    const tabParam = params.get("tab");

    if (tabParam === "inquiry") {
      setActiveTab("inquiry");
    } else if (state?.tab === 2) {
      setActiveTab("magnet_block");
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Main Content */}
      <div className="flex-1 w-full pt-12 md:pt-16 pb-20 px-4 md:px-8 bg-white">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col gap-6 md:gap-8">
            {/* Tab Navigation - 모바일 최적화 */}
            <div className="w-full -mx-4 md:mx-0 px-4 md:px-0 overflow-x-auto">
              <div className="flex gap-2 md:gap-6 justify-center md:justify-start min-w-min md:min-w-full pb-2 md:pb-0">
                <button
                  onClick={() => setActiveTab("faq")}
                  className={`px-4 md:px-6 py-2 md:py-3 rounded-lg md:rounded-full text-sm md:text-base font-medium transition-all whitespace-nowrap ${
                    activeTab === "faq"
                      ? "bg-orange-500 text-white"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  FAQ
                </button>
                <button
                  onClick={() => setActiveTab("worksheet")}
                  className={`px-4 md:px-6 py-2 md:py-3 rounded-lg md:rounded-full text-sm md:text-base font-medium transition-all whitespace-nowrap ${
                    activeTab === "worksheet"
                      ? "bg-orange-500 text-white"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  워크지
                </button>
                <button
                  onClick={() => setActiveTab("magnet_block")}
                  className={`px-4 md:px-6 py-2 md:py-3 rounded-lg md:rounded-full text-sm md:text-base font-medium transition-all whitespace-nowrap ${
                    activeTab === "magnet_block"
                      ? "bg-orange-500 text-white"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  자석블럭 도안
                </button>
                <button
                  onClick={() => setActiveTab("inquiry")}
                  className={`px-4 md:px-6 py-2 md:py-3 rounded-lg md:rounded-full text-sm md:text-base font-medium transition-all whitespace-nowrap ${
                    activeTab === "inquiry"
                      ? "bg-orange-500 text-white"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  고객문의
                </button>
              </div>
            </div>

            {/* Tab Content (Feature Components) */}
            <div className="w-full">
              {activeTab === "faq" && <SupportFAQ />}
              {activeTab === "worksheet" && <SupportWorksheet />}
              {activeTab === "magnet_block" && <SupportMagnetBlock />}
              {activeTab === "inquiry" && <SupportInquiry />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
